import React, { useState } from 'react';
import { MdOutlineKeyboardDoubleArrowUp } from 'react-icons/md';

const ScrollToTopBTN = () => {
    const [visible, setVisible] = useState(false);

    const handleScroll = () => {
        const currentPosition = window.pageYOffset;
        if (currentPosition > 300) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    window.addEventListener('scroll', handleScroll);

    return visible ? (
        <button className="ScrollToTopBTN border border-green-700 rounded text-green-700 hover:text-slate-50 hover:bg-green-700 duration-300 shadow-sm shadow-green-300 animate-bounce" onClick={handleClick}><MdOutlineKeyboardDoubleArrowUp size={30} /></button>
    ) : null;
};

export default ScrollToTopBTN;